import { createWebHistory, createRouter } from 'vue-router';
import { useRegisterTestStore } from '@/store/RegisterTestStore';
import { PatientInterface } from '@/api/interfaces/Patient';

import HomeCovid from '@/views/Covid/Home/Home.vue';
import RegisterTestCovid from '@/views/Covid/RegisterTest/RegisterTest.vue';
import ViewResultCard from '@/views/Covid/ViewResultCard/ViewResultCard.vue';

import HomeHiv from '@/views/Hiv/Home/Home.vue';
import RegisterTestHiv from '@/views/Hiv/RegisterTest/RegisterTest.vue';
import ViewResultCardHiv from '@/views/Hiv/ViewResultCard/ViewResultCard.vue';

import DaskControl from '@/views/Shared/DaskControl/DaskControl.vue';

const arrayRoutesHiv = ['surecheckhiv'];

const canMountCard = (to: any, from: any, next: any) => {
  next();
  const registerStore = useRegisterTestStore();
  const emptyPatient = {} as PatientInterface;

  if (
    registerStore.resultTest != '' &&
    registerStore.testImage != '' &&
    registerStore.testSymptoms != '' &&
    registerStore.patient != emptyPatient
  ) {
    next();
  } else {
    next('/econasal');
  }
};

const routes = [
  {
    path: '/:theme',
    name: 'HomeCovid',
    component: HomeCovid,
  },
  {
    path: '/:theme',
    name: 'HomeHiv',
    component: HomeHiv,
  },
  {
    path: '/:theme/register-test',
    name: 'RegisterTestCovid',
    component: RegisterTestCovid,
  },
  {
    path: '/:theme/register-test',
    name: 'RegisterTestHiv',
    component: RegisterTestHiv,
  },
  {
    path: '/:theme/result-card',
    name: 'ViewResultCard',
    component: ViewResultCard,
    beforeEnter: canMountCard,
  },
  {
    path: '/:theme/result-card',
    name: 'ViewResultCardHiv',
    component: ViewResultCardHiv,
    beforeEnter: canMountCard,
  },
  {
    path: '/:theme/dask-control',
    name: 'DaskControl',
    component: DaskControl,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to: any, from: any) => {
  if (
    !(
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    )
  ) {
    return to.name == "DaskControl" ? true : { name: 'DaskControl', params: to.params };
  } else if (
    from.path == '/' &&
    to.name != 'HomeCovid' &&
    to.name != 'HomeHiv'
  ) {
    return { name: 'HomeCovid', params: to.params };
  } else if (
    from.path == '/' &&
    to.name !== 'HomeHiv' &&
    arrayRoutesHiv.includes(to.params.theme)
  ) {
    return { name: 'HomeHiv', params: to.params };
  } else if (
    arrayRoutesHiv.includes(to.params.theme) &&
    to.name == 'HomeCovid'
  ) {
    return { name: 'HomeHiv', params: to.params };
  }
});

export default router;
